import { Channel } from '@nemuru-eng/js-api-client';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { AddAdminForm } from '@/components/modules/Users/components/AddNewUser/components/UserCredentialsActionDialog/components/AddAdminForm';
import { AddAgentForm } from '@/components/modules/Users/components/AddNewUser/components/UserCredentialsActionDialog/components/AddAgentForm';
import { AddChannelForm } from '@/components/modules/Users/components/AddNewUser/components/UserCredentialsActionDialog/components/AddChannelForm';
import { useUserCredentials } from '@/components/modules/Users/components/AddNewUser/components/UserCredentialsActionDialog/hooks/useUserCredentials';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';

interface UserCredentialsActionDialogProps {
  opened: boolean;
  setOpened: (boolean) => void;
  toggleDialog: () => void;
  credentialsType: UserCredentialsType;
  selectedChannel?: Channel;
}

export const UserCredentialsActionDialog = ({
  opened,
  setOpened,
  toggleDialog,
  credentialsType,
  selectedChannel,
}: UserCredentialsActionDialogProps) => {
  const { handleSubmit, getValues } = useFormContext();
  const { sendRequestByActionType, revalidateStructureAndUsers } = useUserCredentials();

  const [loading, setLoading] = useState(false);

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await sendRequestByActionType({
        action: credentialsType,
        formValues: values,
        selectedChannel,
      });
      await revalidateStructureAndUsers();
      toggleDialog();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ActionDialog
      loading={loading}
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      onSubmit={handleSubmit(() => onSubmit(getValues()))}
      Title={<Text tId={`${credentialsType}_TITLE`} />}
      MainButton={<Text tId={`${credentialsType}_BTN`} />}
      avoidDefaultClose
    >
      {credentialsType === UserCredentialsType.CHANNEL && <AddChannelForm />}
      {credentialsType === UserCredentialsType.ADMIN && <AddAdminForm />}
      {credentialsType === UserCredentialsType.AGENT && <AddAgentForm />}
    </ActionDialog>
  );
};
